import { AuthorizationProfileDto } from "@/core/api/generated/v1";

import { useAppSelector } from "../redux";

/** Returns authorization profile for currently authenticated user. */
export const useAuthorizationProfile = (): {
  authorizationProfile: AuthorizationProfileDto | undefined;
} => {
  const authorizationProfile = useAppSelector((x) => x.auth.authorizationProfile);

  return {
    authorizationProfile,
  };
};
